import React, { useState } from "react";

import type { LawyerRegistrationResult } from "../api/client";

function credentialText(result: LawyerRegistrationResult): string {
  return [
    "中承信合数据服务平台｜律师个人账号登录凭证",
    `登录网址：${result.login_url}`,
    `登录账号：${result.login_account}`,
    `登录密码：${result.password}`,
    `律师编号：${result.lawyer_number}`,
  ].join("\n");
}

export function RegistrationResult({ result }: { result: LawyerRegistrationResult }) {
  const [notice, setNotice] = useState("");
  const copyAll = async () => {
    await navigator.clipboard.writeText(credentialText(result));
    setNotice("全部登录信息已复制");
  };
  const saveCredential = () => {
    const url = URL.createObjectURL(new Blob([credentialText(result)], { type: "text/plain;charset=utf-8" }));
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = `律师账号登录凭证-${result.lawyer_number}.txt`;
    anchor.click();
    URL.revokeObjectURL(url);
    setNotice("登录凭证已保存");
  };
  const shareToSelf = async () => {
    const text = credentialText(result);
    const share = (navigator as unknown as {
      share?: (data: ShareData) => Promise<void>;
    }).share;
    if (share) await share.call(navigator, { title: "律师账号登录凭证", text });
    else await navigator.clipboard.writeText(text);
    setNotice(share ? "分享已完成" : "已复制，可发送给自己");
  };
  return (
    <section className="lawyer-registration-card lawyer-registration-result">
      <div className="lawyer-registration-success" aria-hidden="true">✓</div>
      <h1>{result.registration_status === "CREATED" ? "账号注册成功" : "该账号已经注册"}</h1>
      <p>请妥善保存登录凭证，可直接登录平台。</p>
      <div className="lawyer-credential-card">
        <div className="lawyer-credential-heading">
          <strong>律师个人账号登录凭证</strong>
          <span>{result.registration_status === "CREATED" ? "已创建" : "已注册"}</span>
        </div>
        <dl>
          <div><dt>登录网址</dt><dd>{result.login_url}</dd></div>
          <div><dt>登录账号</dt><dd>{result.login_account}</dd></div>
          <div><dt>登录密码</dt><dd>{result.password}</dd></div>
          <div><dt>律师编号</dt><dd>{result.lawyer_number}</dd></div>
        </dl>
        <button type="button" className="lawyer-registration-copy-all" onClick={() => void copyAll()}>
          一键复制全部登录信息
        </button>
        <small>包含网址、账号、密码和律师编号</small>
      </div>
      <div className="lawyer-registration-warning">请妥善保存账号密码。忘记密码时可通过注册手机号重新验证并查看。</div>
      <div className="lawyer-registration-actions">
        <button type="button" onClick={saveCredential}>保存凭证</button>
        <button type="button" className="is-primary" onClick={() => void shareToSelf()}>分享给自己</button>
      </div>
      {notice && <p className="lawyer-registration-notice" role="status">{notice}</p>}
    </section>
  );
}
